export default __webpack_public_path__ + "static/media/georgia.2a36116f.svg";